<template>
  <div class="nav">
    <div class="logo"><router-link to="/" exact>Home</router-link></div>
    <div class="links">
      <ul>
        <li @click="toggle()"><router-link to="/meteo" >Méteo</router-link></li>
        <li @click="toggle()"><router-link to="/calcul" >Calculatrice</router-link></li>
        <li @click="toggle()"><router-link to="/todo" >To-Do</router-link></li>
        <li @click="toggle()"><router-link to="/sort" >Sort</router-link></li>
      </ul>
    </div>
    <div class="burger" @click="toggle()">
      <div class="line1"></div>
      <div class="line2"></div>
      <div class="line3"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Nav",
  methods:{
    toggle(){
      const nav=document.querySelector('.links');
      const burger=document.querySelector('.burger');
      nav.classList.toggle('nav-active');
      burger.classList.toggle('toggle');
    }
  }
};
</script>
<style scoped>
.nav {
  height: 10vh;
  width: 100vw;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 3em;
  background: #201f32;
}
.nav .logo a {
  font-family: "Lobster", cursive;
  font-size: 2rem;
  text-decoration: none;
  text-transform: uppercase;
  color: #fff;
}
ul {
  display: flex;
}
ul li {
  list-style: none;
}
ul li a {
  display: inline-block;
  color: #fff;
  margin-right: 2em;
  font-weight: 400;
  text-decoration: none;
}
ul li a:hover {
  color: #03a9f4;
}
.burger{
  display: none;
}
.burger div{
  width: 25px;
  height: 3px;
  background-color: rgb(226, 226, 226);
  margin: 5px;
  transition: all 0.3s ease;
}
@media screen and (max-width: 550px) {
  .links{
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: linear-gradient(to bottom, #051937, #004d7a, #008793, #00bf72, #a8eb12);;
    transform: translateX(100%);
    transition: transform 0.25s ease-in;
    z-index: 800;
  }
  ul{
    height: 70%;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
  }
  ul li{
    opacity: 0;
    animation: nav-links-fade 0.5s ease forwards .5s;
  }

  .burger{
    position: absolute;
    right: 0;
    display: block;
    cursor: pointer;
    margin-right: 10px;
    z-index: 900;
  }
  .nav{
    justify-content: space-around;
  }
}
.nav-active{
  transform: translateX(0%);
}
.toggle .line1{
  transform: rotate(-45deg) translate(-5px,6px);
}
.toggle .line2{
  opacity: 0;
}
.toggle .line3{
  transform: rotate(45deg) translate(-5px,-6px);
}

@keyframes nav-links-fade {
  from{
    opacity: 0;
    transform: translateX(50px);
  }
  to{
    opacity: 1;
    transform: translateX(0px);
  }
  
}
</style>